import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import PostCardTextModal from "../../common/layouts/modal/PostCardTextModal";
import Alert from "../../common/layouts/modal/Alert";
import {updatePostCardText} from "@/api";
import {SelectedFilters} from "@/domain/author/AtuhorFilterContainer";
import Paging from "../../common/layouts/page/Paging";


const PostCardList = ({ postCardList, onDelete, onUpdate , currentPage , totalPages , onPageChange  }
                          : { postCardList: any,
    onDelete: (id: number) => void,
    onUpdate: (id: number, msg : string) => void
    currentPage : number,
    totalPages : number,
    onPageChange: (newPage: number) => void;

}) => {


    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState<string >("");
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteId, setDeleteId] = useState<number | null>(null);
    const [postId, setPostId] = useState<number>(0);

    const closeModal = () => {
        setShowAlert(false);
    };

    const handleConfirm = (msg : string) => {

        onUpdate(postId, msg )

        setShowAlert(false);
    };
    const handleClick = (description: string, postCardId : number) => {
        setSelectedMessage(description);
        setPostId(postCardId);
        setShowAlert(true);
    };

    const handleDeleteClick = (id: number) => {
        setDeleteId(id);
        setShowDeleteAlert(true);
    };

    const handleDeleteConfirm = () => {
        if (deleteId !== null) {
            onDelete(deleteId);
            setShowDeleteAlert(false);
            navigate(0);
        }
    };



    return(
        <>
            <div className={"flex flex-col w-full py-4 px-0 gap-6"}>
                <div className={"flex flex-col items-start gap-2"}>
                    <span
                        className={"font-namsan text-[#8D8D8D] text-sm font-medium opacity-80"}>* [삭제] 버튼을 눌러 등록된 엽서를 지울 수 있어요.</span>
                    {postCardList.content && postCardList.content.length > 0 ? (
                        <div className="flex flex-wrap gap-4 justify-start sm1:justify-center">
                            {postCardList.content.map((post: any, index: number) => (
                                <div className={"flex flex-col gap-3 items-center"}>
                                    <div key={index}
                                         onClick={() => handleClick(post.description, post.postCardId)}
                                         className="group relative w-[275px] h-[395px] sm:w-[167px] sm:h-[201px] md:w-[167px] md:h-[201px] cursor-pointer bg-white flex items-center justify-center rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 overflow-hidden">
                                        <img
                                            src={`data:image/png;base64,${post.postCardPhoto}`}
                                            alt={`엽서북 ${post.postCardId}`}
                                            className="w-full h-full object-cover rounded-2xl group-hover:scale-110 transition-transform duration-500"
                                        />
                                        <div
                                            className="absolute bottom-0 w-full h-[70px] bg-opacity-40 text-white font-namsan-B text-lg sm:text-[10px] md:text-[10px] px-4 py-3 rounded-b-2xl group-hover:bg-opacity-60 transition-all"
                                            style={{backgroundColor: 'rgba(0, 0, 0, 0.50)'}}
                                        >
                                            {post.description?.length > 25
                                                ? `${post.description.slice(0, 25)}...`
                                                : post.description}
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => handleDeleteClick(post.postCardId)}
                                        className="w-[165px] h-11 font-namsan flex justify-center items-center rounded-2xl border border-[#D5D8E2] text-sm text-[#8D8D8D] hover:bg-red-50 hover:text-red-500 hover:border-red-200 transition-all active:scale-95">
                                        삭제
                                    </button>


                                </div>


                            ))}
                        </div>
                    ) : (
                        <div className="flex mt-[90px] mb-[90px] md:mt-20 md:mb-20 md:justify-start  justify-center">
                            <span className="text-[22px] font-namsan md:text-[12px] text-[#5B5B5B]">등록된 데이터가 없습니다.</span>
                        </div>


                    )}
                </div>

                <Paging totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange}/>

                <div className={"flex justify-center items-center"}>
                    <button
                        className="w-[320px] md:w-full px-8 py-3.5 border-2 border-main rounded-full bg-white text-main font-namsan-B text-xl sm:text-base md:text-base hover:bg-[#F8FFF9] hover:scale-[1.05] active:scale-95 transition-all shadow-sm"
                        onClick={() => {
                            navigate(-1);
                            setTimeout(() => {
                                window.scrollTo(0, 0);
                            }, 100);
                        }}
                    >
                        마이페이지로 돌아가기
                    </button>
                </div>



                {showAlert && (
                    <PostCardTextModal
                        title="엽서 이야기"
                        message={selectedMessage}
                        onClose={() => setShowAlert(false)}
                        onConfirm={handleConfirm}
                    />
                )}



                {showDeleteAlert && (
                    <Alert
                        title=""
                        message="엽서를 삭제하시겠습니까?"
                        onClose={() => {
                            setShowDeleteAlert(false);
                            }
                        }
                        onConfirm={handleDeleteConfirm}
                    />
                )}


            </div>





        </>
    )


}

export default PostCardList;
